import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

export default function FormacoesPage() {
    const [formacoes, setFormacoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paroquiaNome, setParoquiaNome] = useState('');
    const [grupoNome, setGrupoNome] = useState('');
    const navigate = useNavigate();

    const [grupoIdAusente, setGrupoIdAusente] = useState(false);
    useEffect(() => {
        const fetchFormacoes = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                setGrupoIdAusente(true);
                setLoading(false);
                return;
            }

            const user = JSON.parse(userData);
            const grupoId = user?.grupo_id;
            setParoquiaNome(user?.paroquia || '');
            setGrupoNome(user?.grupo || '');

            if (!grupoId) {
                setGrupoIdAusente(true);
                setLoading(false);
                return;
            }

            try {
                const response = await api.get(`/formacoes/grupo/${grupoId}`);
                setFormacoes(response.data);
            } catch (error) {
                // erro já tratado abaixo
            } finally {
                setLoading(false);
            }
        };

        fetchFormacoes();
    }, []);

  return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-100 to-white flex flex-col items-center px-4 py-8">
            <div className="w-full max-w-5xl bg-white p-8 rounded-2xl shadow-2xl">
                {grupoIdAusente && (
                    <div className="text-center text-red-600 font-semibold py-6 text-lg">
                        Não foi possível identificar o grupo do usuário. Por favor, faça login novamente ou entre em contato com o administrador.
                    </div>
                )}
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-8 gap-4">
                    <div className="flex-1">
                        <h1 className="text-3xl font-extrabold text-gray-800 text-center sm:text-left">
                            Formações <span className="block text-lg font-medium text-green-700">{paroquiaNome || 'Paróquia não identificada'}</span>
                        </h1>
                        {(grupoNome) && (
                            <h2 className="text-lg font-semibold text-green-600 mt-2 text-center sm:text-left">
                                 {grupoNome && `- Grupo: ${grupoNome}`}
                            </h2>
                        )}
                    </div>
                    <button
                        onClick={() => navigate(-1)}
                        className="w-full sm:w-auto px-6 py-3 bg-green-600 text-white rounded-lg font-semibold shadow hover:bg-green-700 transition-colors flex items-center justify-center"
                    >
                        <span className="inline-block align-middle mr-2 text-xl" style={{ verticalAlign: 'middle', minWidth: '20px' }}>←</span>
                        Voltar para Home
                    </button>
                </div>

                {loading ? (
                    <div className="text-center text-gray-500 py-12 text-lg">Carregando formações...</div>
                ) : grupoIdAusente ? null : formacoes.length === 0 ? (
                    <div className="text-center text-gray-500 py-12 text-lg">Nenhuma formação encontrada.</div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {formacoes.map((formacao) => (
                            <div
                                key={formacao.id}
                                className="bg-green-50 border border-green-100 p-6 rounded-xl shadow hover:shadow-md transition"
                            >
                                <h2 className="text-xl font-bold text-green-800">{formacao.titulo}</h2>
                                <p className="text-gray-700 mt-2 whitespace-pre-line">{formacao.descricao}</p>

                                {formacao.links && (
                                    <a
                                        href={formacao.links}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-block mt-4 bg-green-600 text-white px-6 py-3 rounded-lg font-semibold shadow hover:bg-green-700 transition-colors text-center"
                                        style={{ minWidth: 180 }}
                                    >
                                        Acessar formação
                                    </a>
                                )}

                                <div className="flex justify-end mt-4">
                                    <span className="text-xs text-gray-500 italic">
                                        Publicado em:{' '}
                                        {formacao.created_at && !isNaN(new Date(formacao.created_at))
                                            ? (() => {
                                                const d = new Date(formacao.created_at);
                                                if (isNaN(d.getTime())) return '';
                                                const dia = String(d.getUTCDate()).padStart(2, '0');
                                                const mes = String(d.getUTCMonth() + 1).padStart(2, '0');
                                                const ano = d.getUTCFullYear();
                                                return `${dia}/${mes}/${ano}`;
                                            })()
                                            : 'Data não informada'}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}